export default "/img/KH.a138c60105102076320eb5a890ffd96a.png";